const imgTeamGraphic2Main = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const imgDingGra21 = "./assets/figma/4f0256e3-8b20-4011-baab-ae1d9f0482ee.png";
const img1 = "./assets/figma/b6c54e56-def1-4e23-aa6d-bdcb8ddf4751.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine21 = "./assets/figma/855ab069-959b-4910-953b-d071eec60edc.svg";
const imgEllipse30 = "./assets/figma/9427e45b-c7e1-40f9-92e5-1287436540b0.svg";
const imgEllipse31 = "./assets/figma/3d0347f5-34a4-40ac-a394-a629b71a4725.svg";
const imgArrow5 = "./assets/figma/86fee700-6c89-4ef3-a41a-21b7518ecb91.svg";
const imgEllipse37 = "./assets/figma/913dc448-4698-43da-9d8b-57b058da291a.svg";

export default function TeamGraphic2Main() {
  return (
    <div className="s0 s1" data-node-id="772:484" data-name="TEAM_GRAPHIC_2_MAIN">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <img alt="" className="s2 s9 s105 s258 s1" src={imgTeamGraphic2Main} />
      </div>
      <div className="s2 s267 s268 s269 s270" data-node-id="772:490" data-name="image 14" />
      <div className="s106 s2 s607 s937 s265 s609" data-node-id="899:197" data-name="DINGAI_GRA2 1" />
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="1018:110" data-name="navigationbar">
        <a className="s16 s141 s17 s110 s26 s0 s28" data-node-id="1018:111">
          <div className="s111 s0 s28 s112" data-node-id="1018:112" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="1018:117">
            DING AI LAB
          </p>
        </a>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="1018:118">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="1018:119">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:120">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:121">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="1018:122">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:123">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:124">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <a className="s16 s141 s17 s24 s118 s18 s0 s28 s124" data-node-id="1018:125">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="1018:126">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="1018:127">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </a>
        </div>
      </div>
      <div className="s259 s2 s16 s17 s24 s938 s18 s19 s466 s273 s274 s275 s276 s145 s146 s261 s278" data-node-id="1018:128">
        <div aria-hidden className="s2 s147 s3 s4 s145" />
        <div className="s16 s17 s24 s279 s26 s0 s28 s280" data-node-id="1018:129">
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s34" data-node-id="1018:130">
            graphic 2 AI RECIPE
          </p>
          <div className="s46 s0 s28 s34" data-node-id="1018:131">
            <div className="s2 s48">
              <img alt="" className="s49 s9 s1" src={imgLine21} />
            </div>
          </div>
        </div>
        <div className="s16 s17 s24 s293 s939 s26 s0 s28 s297" data-node-id="1018:132">
          <div className="s16 s17 s298 s18 s0 s28 s34" data-node-id="1018:133">
            <div className="s0 s28 s299" data-node-id="1018:134">
              <div className="s2 s300">
                <img alt="" className="s49 s9 s1" src={imgEllipse30} />
              </div>
            </div>
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="1018:135">
              CHATGPT
            </p>
          </div>
          <div className="s16 s17 s298 s18 s0 s28" data-node-id="1018:136">
            <div className="s0 s28 s299" data-node-id="1018:137">
              <div className="s2 s300">
                <img alt="" className="s49 s9 s1" src={imgEllipse31} />
              </div>
            </div>
            <p className="s23 s301 s302 s32 s27 s0 s28 s29 s281 s54" data-node-id="1018:138">
              JEMINI
            </p>
          </div>
        </div>
        <a className="s282 s16 s141 s17 s24 s283 s284 s18 s42 s285 s286 s287 s0 s145 s146 s28 s288 s289 s290" data-node-id="1018:142" data-name="ARCHIVE1">
          <div className="s16 s17 s18 s19 s0 s28 s34" data-node-id="1018:143">
            <p className="s23 s31 s32 s27 s0 s28 s29 s37 s149 s54" data-node-id="1018:144">
              ARCHIVE
            </p>
            <div className="s46 s0 s28 s291" data-node-id="1018:145">
              <div className="s2 s292">
                <img alt="" className="s49 s9 s1" src={imgArrow5} />
              </div>
            </div>
          </div>
        </a>
        <div className="s2 s3 s4 s150 s151" />
      </div>
      <div className="s259 s2 s16 s17 s24 s230 s26 s303 s277 s304" data-node-id="1018:153" data-name="TAB_TEAM">
        <a className="s16 s141 s17 s305 s18 s306 s307 s308 s309 s0 s145 s146 s28 s304" data-node-id="1018:158" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s149 s119" data-node-id="1018:159">
            GRAPHIC 1
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <div className="s16 s81 s17 s305 s18 s306 s307 s308 s309 s0 s145 s28 s304" data-node-id="772:500" data-name="TAB_TEAM_GRAPHIC2">
          <div aria-hidden className="s2 s152 s3 s4 s145" />
          <div className="s16 s17 s18 s19 s0 s28 s318" data-node-id="772:501">
            <p className="s23 s31 s310 s32 s27 s0 s28 s29 s281 s614" data-node-id="772:502">
              GRAPHIC 2
            </p>
            <div className="s0 s28 s320" data-node-id="772:503">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgEllipse37} />
            </div>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </div>
        <a className="s16 s141 s17 s24 s305 s26 s42 s311 s307 s312 s309 s0 s145 s146 s28 s34" data-node-id="1018:160" data-name="TAB_TEAM_UI/UX">
          <div aria-hidden className="s2 s313 s3 s4 s145" />
          <div className="s16 s17 s314 s18 s19 s0 s28 s315" data-node-id="1018:161">
            <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1018:162">
              UI/UX
            </p>
          </div>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s311 s307 s316 s309 s0 s145 s146 s28 s34" data-node-id="1018:163" data-name="TAB_TEAM_PACKAGE">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1018:164">
            PACKAGE
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
        <a className="s16 s141 s17 s305 s18 s306 s307 s317 s309 s0 s145 s146 s28 s34" data-node-id="1018:165" data-name="TAB_TEAM_MOTION">
          <div aria-hidden className="s2 s147 s3 s4 s145" />
          <p className="s23 s31 s32 s27 s0 s28 s29 s281 s149 s54" data-node-id="1018:166">
            MOTION
          </p>
          <div className="s2 s3 s4 s150 s151" />
        </a>
      </div>
      <div className="s106 s259 s2 s126 s260 s261" data-node-id="1035:569" data-name="DING_GRA2 1">
        <img alt="" className="s2 s3 s9 s262 s4 s1" src={imgDingGra21} />
      </div>
    </div>
  );
}